export default __webpack_public_path__ + "6d794b8a06cc11742593917b013dd938.png";